module.exports = __webpack_public_path__ + "fonts/KXGjmobj.woff2";